﻿import React from "react";
import { useSelector } from "react-redux";
import { RootState, useThunkDispatch } from "../../store/index";
import _ from "lodash";
import { EditableValueField } from "./shared";
import { Button } from "../../shared/components";
import { updateParameterValue } from "../../store/storyline/actions";
import { jsonParseReviver } from "../../shared/api-client";
import { createSelector } from "@reduxjs/toolkit";

type ParameterValuesProps = {
};

function ParameterValues(_props: ParameterValuesProps) {
    const parameterValueEntriesSelector = createSelector(
        [
            (state: RootState) => state.storyline.parameterValues
        ],
        (parameterValues) => [...parameterValues.entries()]
    )
    const parameterValueEntries = useSelector(parameterValueEntriesSelector);

    return (
        <div className="table-container">
            <table className="table bordered no-header key-value">
                <tbody>
                    {
                        parameterValueEntries.map(([name, value]) => <ParameterValueRow key={name} name={name} value={value} />)
                    }
                </tbody>
            </table>
        </div>
    );
}

interface ParameterValueRowProps {
    name: string;
    value: any;
}

function ParameterValueRow(props: ParameterValueRowProps) {
    const { name, value } = props;

    const dispatch = useThunkDispatch();
    const [modifiedValue, setModifiedValue] = React.useState(JSON.stringify(value, null, 2));

    React.useEffect(() => {
        setModifiedValue(JSON.stringify(value, null, 2));
    }, [value]);

    const applyChanges = React.useCallback(() => {
        try {
            const parsedValue = JSON.parse(modifiedValue, jsonParseReviver);
            dispatch(updateParameterValue(name, parsedValue));
        }
        catch (e) {

        }
    }, [name, modifiedValue]);

    return (
        <tr key={name}>
            <td className="heading-cell">
                {name}
            </td>
            <td>
                <EditableValueField value={value} onChange={setModifiedValue} />
            </td>
            <td>
                <Button variant="contained" color="secondary" size="small" onClick={applyChanges}>Apply Changes</Button>
            </td>
        </tr>
    );
}

export default React.memo(ParameterValues);